/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PaymentMethod } from "./PaymentMethod";
import {
  PaymentMethodFromJSON,
  PaymentMethodFromJSONTyped,
  PaymentMethodToJSON,
  PaymentMethodToJSONTyped,
} from "./PaymentMethod";

/**
 *
 * @export
 * @interface MarkInvoicesSettlementPendingBulkRequest
 */
export interface MarkInvoicesSettlementPendingBulkRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof MarkInvoicesSettlementPendingBulkRequest
   */
  customerInvoiceIds: Array<string>;
  /**
   *
   * @type {PaymentMethod}
   * @memberof MarkInvoicesSettlementPendingBulkRequest
   */
  paymentMethod: PaymentMethod;
  /**
   *
   * @type {string}
   * @memberof MarkInvoicesSettlementPendingBulkRequest
   */
  paymentReference: string;
  /**
   *
   * @type {string}
   * @memberof MarkInvoicesSettlementPendingBulkRequest
   */
  batchId?: string | null;
}

/**
 * Check if a given object implements the MarkInvoicesSettlementPendingBulkRequest interface.
 */
export function instanceOfMarkInvoicesSettlementPendingBulkRequest(
  value: object,
): value is MarkInvoicesSettlementPendingBulkRequest {
  if (
    !("customerInvoiceIds" in value) ||
    value["customerInvoiceIds"] === undefined
  )
    return false;
  if (!("paymentMethod" in value) || value["paymentMethod"] === undefined)
    return false;
  if (!("paymentReference" in value) || value["paymentReference"] === undefined)
    return false;
  return true;
}

export function MarkInvoicesSettlementPendingBulkRequestFromJSON(
  json: any,
): MarkInvoicesSettlementPendingBulkRequest {
  return MarkInvoicesSettlementPendingBulkRequestFromJSONTyped(json, false);
}

export function MarkInvoicesSettlementPendingBulkRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MarkInvoicesSettlementPendingBulkRequest {
  if (json == null) {
    return json;
  }
  return {
    customerInvoiceIds: json["customerInvoiceIds"],
    paymentMethod: PaymentMethodFromJSON(json["paymentMethod"]),
    paymentReference: json["paymentReference"],
    batchId: json["batchId"] == null ? undefined : json["batchId"],
  };
}

export function MarkInvoicesSettlementPendingBulkRequestToJSON(
  json: any,
): MarkInvoicesSettlementPendingBulkRequest {
  return MarkInvoicesSettlementPendingBulkRequestToJSONTyped(json, false);
}

export function MarkInvoicesSettlementPendingBulkRequestToJSONTyped(
  value?: MarkInvoicesSettlementPendingBulkRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    customerInvoiceIds: value["customerInvoiceIds"],
    paymentMethod: PaymentMethodToJSON(value["paymentMethod"]),
    paymentReference: value["paymentReference"],
    batchId: value["batchId"],
  };
}
